import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const TieredInterventionContainer = styled.div`
  background-color: ${themeGet('colors.tieredInterventionTeal', '#2D5C5C')};
  border-radius: 0.688rem;
  padding: 2rem 1.75rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  top: -2rem;
  z-index: 10;

  ${themeGet('breakpoints.mobileLarge')} {
    padding: 1.5rem 1.25rem;
    top: -1.5rem;
  }
`

export const TieredInterventionTitle = styled.h2`
  font-family: ${themeGet('fonts.primary')};
  font-weight: 800;
  font-size: 1.75rem;
  color: ${themeGet('colors.tieredIntervention.calloutText', '#FFFFFF')};
  margin: 0 0 0.5rem 0;
  line-height: 1.2;

  ${themeGet('breakpoints.mobileLarge')} {
    font-size: 1.5rem;
  }
`

export const TieredInterventionDescription = styled.p`
  font-family: ${themeGet('fontFamily')};
  font-weight: 400;
  font-size: 1rem;
  color: ${themeGet('colors.tieredIntervention.calloutText', '#FFFFFF')};
  margin: 0;
  line-height: 1.4;
  opacity: 0.95;

  ${themeGet('breakpoints.mobileLarge')} {
    font-size: 0.9375rem;
  }
`

export const TieredInterventionFooter = styled.div`
  margin-top: 1rem;
`
